import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useExecuteExportJob(shop: ShopDto) {
	const invalidateShop = useInvalidateShop(shop.id);

	return useApiMutation(
		"post",
		"/shops/{shopId}/exports/{exportId}",
		{
			invalidate: invalidateShop,
			mapVariables: (exportId: string) => ({
				params: { path: { shopId: shop.id, exportId } },
			}),
		},
	);
}
